import React, { FC } from 'react'
import { Text } from 'components/Text'
import { useTranslation } from 'react-i18next'

export const TrafficDescription: FC = () => {
  const { t } = useTranslation()

  return <Text>{t('confirmation_banner.TRAFFIC_TOOL.TRAFFIC_TOOL.click_on_map')}</Text>
}

TrafficDescription.displayName = 'TrafficDescription'
